import { useTranslation } from 'react-i18next'
import { Box, Skeleton } from '@mantine/core'

import { DashboardCard } from '../DashboardCard/DashboardCard'

import { sanitizeRichDescription } from '@percent/lemonade'
import { useLogger, useQuery } from '@percent/workplace-giving/common/hooks'
import { getGamificationDisplayConfig } from '@percent/workplace-giving/api/gamification/getGamificationDisplayConfig'
import { GamificationBadges } from '@percent/workplace-giving/common/components/GamificationBadges/GamificationBadges'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'
import classes from './FoundationRewards.module.scss'

export function FoundationRewards() {
  const { t } = useTranslation()
  const { logError } = useLogger()

  const { data, isPending, error } = useQuery(['getGamificationDisplayConfig'], getGamificationDisplayConfig, {
    staleTime: 1000 * 60
  })

  if (isPending) {
    return <Skeleton data-testid="gamification-section-loader" variant="rectangular" width="100%" height={100} />
  }

  if (error) {
    logError(error)

    return null
  }

  return (
    <DashboardCard
      title={data?.title ?? t('workplace_giving.sidePanel.achievements')}
      seeAllHref={AppRoute.MY_ACHIEVEMENTS}
    >
      <Box className={classes.Spacer} />
      <Box>
        <GamificationBadges />
        {data?.body && (
          <Box
            className={classes.Footer}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizeRichDescription(data.body, { ALLOWED_TAGS: ['p', 'a'] })
            }}
          />
        )}
      </Box>
    </DashboardCard>
  )
}
